import axios from 'axios';
import { API_ENDPOINT, AZURE_STORAGE_URL } from '@/configs';
import { logoutServices, syncStorageIntoStateService } from '../services';
import { getTenantId } from '../functions';
import { localStorageLabels } from '../constants';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

/**
 * Base API instance for general requests.
 * - Sets the base URL from environment config.
 * - Enables credentials (cookies/auth headers) for cross-origin requests.
 * - Default headers for JSON content.
 */
export const API = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true, // Send cookies/auth tokens
  headers,
});

/**
 * Azure Storage API instance.
 * - Dynamically constructs the base URL using the tenant ID.
 * - Used for interacting with Azure Blob Storage or similar services.
 */
export const AZURE_STORAGE_API = axios.create({
  baseURL: AZURE_STORAGE_URL + getTenantId() + '/',
  headers,
});

API.interceptors.request.use(
  (config) => {
    const tid = syncStorageIntoStateService(localStorageLabels.TID);
    const localData = syncStorageIntoStateService(
      localStorageLabels.LOCAL_DATA,
    );
    const accessToken = localData?.token;

    if (accessToken) config.headers['Authorization'] = 'Bearer ' + accessToken;
    if (tid) config.headers['X-TENANT'] = tid;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    if (error?.response?.status === 401) {
      Promise.resolve(logoutServices()).then(() => {
        window.location.href = '/auth/login';
      });
    }

    return Promise.reject(error);
  },
);
